export function renderResolveMediaFunctionIdsTemplate({
  ctxSingular,
  collectSingle,
  collectArrayContent,
  map,
  arrayFieldsContent,
  assignSingle,
  assignArrayContent
}: {
  ctxSingular: string
  collectSingle: string
  collectArrayContent: string
  map: string
  arrayFieldsContent: string
  assignSingle: string
  assignArrayContent: string
}): string {
  return `export async function resolve${ctxSingular}MediaFields(rows: ${ctxSingular}[]): Promise<${ctxSingular}[]> {
  if (rows.length === 0) return rows

  const ids = new Set<string>()
${collectSingle}${collectArrayContent}

  if (ids.size === 0) {
    for (const row of rows) {
${map}${arrayFieldsContent}
    }
    return rows
  }

  const mediaRows = await db.select().from(adminMedia).where(inArray(adminMedia.id, [...ids]))
  const mediaMap = new Map<string, AdminMedia>(mediaRows.map(m => [m.id, m]))

  for (const row of rows) {
${assignSingle}${assignArrayContent}
  }

  return rows
}`
}
